/**
 * captureRecinto — Lee ?recinto=<token> de la URL y persiste en sessionStorage.
 *
 * Estrategia de persistencia (mismo patrón que utm.js):
 *   1. Si el param existe en la URL → usarlo y guardarlo en sessionStorage.
 *   2. Si no está en la URL → recuperar desde sessionStorage (navegación interna).
 *   3. Si tampoco está en sessionStorage → string vacío.
 *
 * Esto garantiza que el deep-link ?recinto= funcione aunque el usuario recargue
 * o navegue entre pasos del wizard sin perder el recinto preseleccionado.
 */
export function captureRecinto() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("recinto") || sessionStorage.getItem("recinto_token") || "";
  if (token) sessionStorage.setItem("recinto_token", token);
  return token;
}
